import { v4 as uuid } from "uuid";

import { formatRoleName } from "../utils/utils";

import { Permission } from "./Permission";

export const Role = ({ role, organization, permissions }) => {
  return {
    id: uuid(),
    name: role,
    label: formatRoleName(role),
    organization,
    permissions: permissions.map((p) => new Permission(p)),
  };
};
